import React from "react";
import html from "../../Assets/skillsImage/html.png";
import css from "../../Assets/skillsImage/css.png";
import javaScript from "../../Assets/skillsImage/javaScript.png";
import Reactpng from "../../Assets/skillsImage/Reactpng.png";
import Redux from "../../Assets/skillsImage/Redux.png";
import nodejs from "../../Assets/skillsImage/nodejs.png";
import expressjs from "../../Assets/skillsImage/expressjs.png";
import mongoDB from "../../Assets/skillsImage/mongoDB.png";
import materialui from "../../Assets/skillsImage/materialui.png";
import git from "../../Assets/skillsImage/git.png";
import bootStrap from "../../Assets/skillsImage/bootstrap.png";
import npm from "../../Assets/skillsImage/npm.png";
import styles from "./Skills.module.css";

const Skills = () => {
  return (
    <div className={styles.mainSkills}>
      <h1>Skills</h1>
      <div className={styles.skill}>
        <div className={styles.logo}>
          <img style={{ width: "5.5vw" }} src={html} />
          <p>HTML</p>
        </div>
        <div className={styles.logo}>
          <img style={{ width: "8vw" }} src={css} />
          <p>CSS</p>
        </div>
        <div className={styles.logo}>
          <img style={{ width: "5.5vw" }} src={javaScript} />
          <p>JavaScript</p>
        </div>
        <div className={styles.logo}>
          <img style={{ width: "6.5vw" }} src={Reactpng} />
          <p>React</p>
        </div>
        <div className={styles.logo}>
          <img style={{ width: "6vw" }} src={Redux} />
          <p>Redux</p>
        </div>
        <div className={styles.logo}>
          <img style={{ width: "15vw" }} src={nodejs} />
          <p>Node JS</p>
        </div>
        <div className={styles.logo}>
          <img style={{ width: "15vw" }} src={expressjs} />
          <p>Express JS</p>
        </div>
        <div className={styles.logo}>
          <img style={{ width: "7vw" }} src={mongoDB} />
          <p>Mongo DB</p>
        </div>
        <div className={styles.logo}>
          <img style={{ width: "7.5vw" }} src={materialui} />
          <p>Material UI</p>
        </div>
        <div className={styles.logo}>
          <img style={{ width: "7vw" }} src={git} />
          <p>GIT</p>
        </div>
        <div className={styles.logo}>
          <img style={{ width: "7vw" }} src={bootStrap} />
          <p>Bootstrap</p>
        </div>
        <div className={styles.logo}>
          <img style={{ width: "7vw" }} src={npm} />
          <p>npm</p>
        </div>
      </div>
    </div>
  );
};

export default Skills;
